/**
 * This file includes polyfills needed by Angular and is loaded before the app.
 * You can add your own extra polyfills to this file.
 */

/***************************************************************************************************
 * BROWSER POLYFILLS
 */

// By default, modern Angular apps don’t need anything extra here for modern browsers

/***************************************************************************************************
 * Zone JS is required by Angular itself.
 */
import 'zone.js';  // Included with Angular CLI

/***************************************************************************************************
 * APPLICATION IMPORTS
 */
// You can add any global scripts you need
